import { Cross1Icon } from "@radix-ui/react-icons";
import { Dialog, Flex, Heading, IconButton, Text } from "@radix-ui/themes";
import { createCallable } from "react-call";
import { QRScanner } from "./qr-scanner";
import { z } from "zod";
import { useState } from "react";

interface Props {
  onScanned?: () => void;
}
type Response = void;

export const CustomerHelp = createCallable<Props, Response>(
  ({ call, onScanned }) => {
    const [schema] = useState(() =>
      z.object({
        isAdmin: z.boolean(),
      })
    );

    return (
      <Dialog.Root
        open
        onOpenChange={(value) => {
          if (!value) {
            call.end();
          }
        }}
      >
        <Dialog.Content className="!p-6">
          <Dialog.Title align="center">Customer Help</Dialog.Title>
          <Dialog.Close>
            <IconButton
              variant="soft"
              color="gray"
              className="!absolute !top-2 !right-2"
            >
              <Cross1Icon />
            </IconButton>
          </Dialog.Close>
          <Flex className="h-[400px]">
            <Flex direction="column" justify="center" className="h-full">
              <Heading mb="4">
                Oops! Looks like there's an issue with your cart
              </Heading>
              <Text size="5" color="gray">
                Please contact the store manager for help.
              </Text>
            </Flex>

            <figure>
              <img src="/customer-help.png" />
            </figure>
          </Flex>
          <QRScanner
            onScanned={() => {
              onScanned?.();
              call.end();
            }}
            schema={schema}
          />
        </Dialog.Content>
      </Dialog.Root>
    );
  }
);
